import { toast, ToastOptions } from 'react-toastify';
import { INotification } from '../../types/UI/Notification.type';

// eslint-disable-next-line import/prefer-default-export
export const sendNotification = ({
  type = 'info',
  message = '',
  autoClose = 5000,
}: INotification) => {
  const configuration: ToastOptions = {
    position: 'top-right',
    autoClose,
    theme: 'colored',
  };

  switch (type) {
    case 'success':
      toast.success(message, configuration);
      break;
    case 'error':
      toast.error(message, configuration);
      break;
    case 'info':
      toast.info(message, configuration);
      break;
    case 'warning':
      toast.warn(message, configuration);
      break;
    default:
      toast(message, configuration);
      break;
  }
};
